import { Api } from "../config/request";

export default {
  getAssetList() {
    return Api.get("/assets");
  },
  createOrUpdateAsset(payload) {
    return Api.post("/assets", payload);
  },
};
